<template>
	<div class="download-gpx-card">
		<h1>Instrucciones</h1>

		<p>
			Para poder competir es necesario que descargue el archivo GPX que
			proporcionamos aquí para poder seguirlo con su reloj
			deportivo/aplicación favorita.
			<br />
			<b
				>Es muy importante que empiece y termine de grabar en los puntos
				inicial y final de la carrera para que se procesen
				correctamente.</b
			>
			<br />
			Una vez grabado, simplemente suba los resultados a esta misma
			página.
		</p>

		<div class="card-actions">
			<v-spacer></v-spacer>
			<v-btn
				class="rounded-lg"
				elevation="0"
				color="success"
				:href="gpxRoute"
				block
				x-large
				>Descargar ruta</v-btn
			>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			raceId: String,
		},
		computed: {
			gpxRoute() {
				return `${process.env.VUE_APP_BACK_URL}/api/race/download?id=${this.raceId}`;
			},
		},
	};
</script>

<style lang="scss" scoped>
	.download-gpx-card {
		h1 {
			margin-bottom: 0.6em;
		}

		p {
			margin: 0;
			text-align: justify;
			font-size: 1.1em;
			line-height: 1.8em;
		}

		.card-actions {
			margin-top: 2em;
			display: flex;
			flex-wrap: wrap;
		}
	}
</style>
